// extracted by mini-css-extract-plugin
export default {"ApplicationError":"TqKfLGoeJstRQJlf7IHT","Heading":"n2pOcYiFNDiNzBjdPbor","Body":"K4Rvkc1MBSsVzDNuhYAB","Variant--withoutHeading":"TMOLHKbEVRY_k6ERzYhy"};